import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface GolfRegistration {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string | null;
  golf_index: number;
  payment_status: string;
  created_at: string;
  teammate: string | null;
  amount: number;
  additional_donation: number;
}

export const useGolfData = () => {
  const [registrations, setRegistrations] = useState<GolfRegistration[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchRegistrations = async () => {
      try {
        setIsLoading(true);
        const { data, error: fetchError } = await supabase
          .from("golf_registrations")
          .select(
            "id, first_name, last_name, email, phone, golf_index, payment_status, created_at, teammate, amount, additional_donation"
          )
          .order("created_at", { ascending: false });

        if (fetchError) throw fetchError;
        setRegistrations((data as GolfRegistration[]) || []);
      } catch (err) {
        console.error("Error fetching golf registrations:", err);
        setError(err instanceof Error ? err : new Error("Unknown error"));
      } finally {
        setIsLoading(false);
      }
    };

    fetchRegistrations();
  }, []);

  return { registrations, isLoading, error };
};
